import * as Papa from '../../../libjs/papaparse/papaparse.js';
import * as $ from "jquery";
export var resultsCsv = {};
import * as globals from '../../Globals/Globals';
import * as csvdatatype from '../../datasets/datasets.json';
import * as d3 from "d3";

export var countValues = new Map<string,Map<String,Number>>();
export var loadValues = new Map<String,Array<any>>();
export var loadValues1 = new Array<Map<String,Number>>();
export var maxValues = new Map<String,Number>();
export var dimensions = new Array<any>();
export var allValues = new Map<String,any>();


export class Dimension{

    name: string;
    scale: any;
    type: string
    
}


export function loadData() {
    var activeDataset = csvdatatype['activeDataset']
    globals.datasetMode.activeDataset = csvdatatype['activeDataset']
    globals.datasetMode.mode = csvdatatype[activeDataset] ['mode']
    globals.dataset.records = csvdatatype[activeDataset] ['records'].toString()

    globals.dataset.attributes = csvdatatype[activeDataset] ['attributes']
    globals.dataset.attributes_types = csvdatatype[activeDataset] ['attribute_types']
    globals.dataset.attributes_content = csvdatatype[activeDataset] ['attribute_content']
    globals.dataset.attribute_description = csvdatatype[activeDataset] ['attribute_description']
    

    var attrNum:number = 0;
    globals.dataset.attributes.forEach(element => {
      var attr:string = "attributes_"+attrNum;
      globals.dataset.datasetMap.set(attr,element);
      attrNum = attrNum + 1;
      
    });
    var attrNum:number = 0;
    globals.dataset.attributes_types.forEach(element => {
      var attr:string = "attributes_"+attrNum;
      globals.dataset.datasetTypesMap.set(attr,element);
      attrNum = attrNum + 1;
     
     
      
    });

    for(var key in csvdatatype[activeDataset] ['attribute_records']){
        var scale
        var type
        if(csvdatatype[activeDataset] ['attribute_records'][key] == 'string')
        {
            scale =  d3.scalePoint()
            type = 'string'
        }
        else if(csvdatatype[activeDataset] ['attribute_records'][key] == 'time')
        {
            scale = d3.scaleLinear()
            type = 'number'
        }
        else if(csvdatatype[activeDataset] ['attribute_records'][key] == 'float')
        {
            scale = d3.scaleLinear()
            type = 'number'
        }
        dimensions.push({
            'name': key,
            'scale':scale,
            'type':type
        })
    }
  
  }
export function loadDataSet(){

    var activeDataset = csvdatatype['activeDataset']
    Papa.parse('https://research.vis.ninja/PredictVis/datasets/'+activeDataset+".csv", 
                {
                header: true, 
                delimiter: ',',
                skipEmptyLines: true,
                worker: true,
                download: true,
                complete: function(results) {
                    var dataset = results.data;
                    var count = 1 
                    $.each(dataset, function (index, value) {
                       
                            allValues[count.toString()]= value
                       
                        count = count + 1
                        
                    });
                    console.log('allValues',allValues)
                   
                  
                }
            });

}

export function loadCsvData(){
    var activeDataset = csvdatatype['activeDataset']
    var attributes = csvdatatype[activeDataset] ['attribute_records']
    Papa.parse('https://research.vis.ninja/PredictVis/datasets/'+activeDataset+'.csv', {
        header: true,
        worker: true,
        delimiter: ',',
        download: true,
        complete: function(results, file) {
            results = results.data
            $.each(results, function (index, value) {
        
                var valuesMap = new Map<String,Number>();
                for (let key in value) {
                   
                    if (key in countValues){
                    
                       
                        if(value[key] in countValues[key]){
                            countValues[key][value[key]] = countValues[key][value[key]] + 1
                        }
                        else{
                            countValues[key][value[key]] = 0
                        }
                        if(attributes[key] == 'time' || attributes[key] == 'string')
                        {
                            loadValues[key].push(String(value[key]))
                        }
                        else{
                            loadValues[key].push(Number(value[key]))
                        }
                       
                    }
                    else
                    {
                        loadValues[key] = []
                        countValues[key] = {}
                    }

                    if(attributes[key] == 'time' || attributes[key] == 'string')
                    {
                        valuesMap[key] = String(value[key])
                    }
                    else{
                        valuesMap[key] = Number(value[key])
                    }
                   
                }
                loadValues1.push(valuesMap)
               
               
            });
            $.each(loadValues1, function (index, value) {
                dimensions.forEach(function(dimension) {
                    dimension.scale.domain(dimension.type === "number"
                        ? d3.extent(loadValues1, function(d) { return +d[dimension.name]; })
                        : loadValues1.map(function(d) { return d[dimension.name]; }).sort());
                })
            })
            console.log('loadValues1',loadValues1, loadValues)

        }
    });

}